// Removed logoutUser import

const Logout = () => {
  // const dispatch = useDispatch(); // Not used if we remove logoutUser
  const pb = useContext(PocketBaseContext);

  useEffect(() => {
    const performLogout = async () => {
      try {
        if (pb.authStore.isValid) {
          await pb.authStore.clear();
        }
        sessionStorage.removeItem("authUser"); // Clean up legacy auth item if present
        // dispatch(logoutUser()); // Removed dispatch
      } catch (error) {
        console.error("Çıkış sırasında bir hata oluştu:", error);
      }
    };

    performLogout();
  }, [pb]);

  return <Navigate to="/login" />;
};

export default Logout;